import type { FC } from 'react';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import type { FontWeight } from '@/theme/typography';
const SEQUENCE_TEXT_ALIGN_START = 'start';
const SEQUENCE_TEXT_ALIGN_CENTER = 'center';
const SEQUENCE_TEXT_MARKDOWN_ALIGN_LEFT = 'left';
const SEQUENCE_TEXT_JUSTIFY_FLEX_START = 'flex-start';
type SequenceTextAlign = typeof SEQUENCE_TEXT_ALIGN_START | typeof SEQUENCE_TEXT_ALIGN_CENTER;
interface SequenceTextProps {
    x: number;
    y: number;
    width: number;
    height: number;
    content: string;
    size: number;
    weight: FontWeight;
    color: string;
    align?: SequenceTextAlign;
    /** Horizontal inset, mirroring the SVG `<text>` start-anchor padding. */
    padX?: number;
}
/**
 * A sequence-diagram text label rendered as real HTML inside an SVG
 * `<foreignObject>`, so it flows through `Cmarkdown` (markdown + `[[references]]`
 * + the app font) like every other widget — SVG `<text>` can't host either.
 * Centered (or left-aligned) within the given box; `overflow: visible` keeps an
 * under-estimated box from clipping the (proportional) rendered text.
 */
export const SequenceText: FC<SequenceTextProps> = ({ x, y, width, height, content, size, weight, color, align = SEQUENCE_TEXT_ALIGN_CENTER, padX = 0, }) => {
    return (
      <foreignObject x={x} y={y} width={width} height={height} style={{ overflow: 'visible' }}>
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: align === SEQUENCE_TEXT_ALIGN_CENTER
                ? SEQUENCE_TEXT_ALIGN_CENTER
                : SEQUENCE_TEXT_JUSTIFY_FLEX_START,
            padding: `0 ${padX}px`,
            boxSizing: 'border-box',
        }}>
          <CmarkdownLabelText content={content} size={size} weight={weight} textAlign={align === SEQUENCE_TEXT_ALIGN_CENTER
            ? SEQUENCE_TEXT_ALIGN_CENTER
            : SEQUENCE_TEXT_MARKDOWN_ALIGN_LEFT} style={{ minWidth: 0, maxWidth: '100%' }} paragraphStyle={{
            marginBottom: 0,
            minWidth: 0,
            justifyContent: align === SEQUENCE_TEXT_ALIGN_CENTER
                ? SEQUENCE_TEXT_ALIGN_CENTER
                : SEQUENCE_TEXT_JUSTIFY_FLEX_START,
        }} textStyle={{ color, whiteSpace: 'nowrap' }}/>
        </div>
      </foreignObject>
    );
};
